import {
  upload,
} from "@/api/claim";

const state = {
  policy_no: "",
  policy_info: {},
};

const mutations = {
  SET_POLICY_NO(state, val) {
    state.policy_no = val;
  },
  SET_POLICY_INFO(state, val) {
    state.policy_info = val;
  },
};

const actions = {
  upload(context, data) {
    return new Promise((resolve) => {
      upload(data).then((res) => {
        if (res && res.err_code === 0) {
          resolve(res);
        }
      });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
